

const data = {
  key: 'winter-schedule-template',
  name: 'Winter Schedule Template',
};
export default data;
